<template>

  <div class="home-wrap">

    <img class="top-img" src="../../../assets/imgs/banner2.jpeg">
    <div class="contact-us-wrap">
      <div class="left-wrap">

        <div class="head-txt">
          业务范围/核心技术
        </div>
        <div @click="qiehuanTab(0)" :class="currTab == 0 ?'item-txt item-txt-select':'item-txt'"
        >
          {{ menuList[0].text }}
        </div>

        <div @click="qiehuanTab(1)" :class="currTab == 1 ?'item-txt2 item-txt2-select':'item-txt2'"
        >
          <div class="item2-txt">{{ menuList[1].text }}</div>
          <template v-if="isOpen">
            <img src="../../../assets/imgs/open-ic.png">
          </template>
          <template v-else>
            <img src="../../../assets/imgs/close-ic.png">
          </template>
        </div>

        <template v-if="isOpen">
          <div @click="qiehuanHxTab(index)" :class="currHexin == index ?'hxitem-txt item-txt-select':'hxitem-txt'"
               v-for="(txt, index) in hexinList">
            {{ txt.title }}
          </div>
        </template>
        <div style="height: 40px"></div>
      </div>

      <div class="right-wrap">

        <div style="width: 100%;height: 1px;background-color: #333333"></div>

        <div class="text-title">
          当前位置：
          <div class="a-a" @click="goHome">首页</div>
          > 业务范围/核心技术 > {{ menuList[currTab].text }}
          <img class="c-us" src="../../../assets/imgs/serve-phone.png">
          <div class="c-line"></div>
        </div>

        <template v-if="currTab==0">

          <div class="ywfw-top-wrap">
            <img src="../../../assets/imgs/white-top.png">
            <div style="height: 40px"></div>
            <div class="text">公司坚持为客户提供最优质服务的宗旨，</div>
            <div class="text">为客户提供从技术咨询、可行性研究，手续办理、项目建设、工程调试直至技术升级改造的全生命周期服务，</div>
            <div class="text">并在业务范围内可灵活、专业、高效的提供以下服务：</div>
            <div style="height: 70px"></div>
          </div>

          <div class="item-tech-wrap">
            <img src="../../../assets/imgs/jszx-icon.png">
            <div class="info-wrap">
              <div class="title">技术咨询</div>
              <div class="desc">提供项目前期技术交流、可行性研究报告编制服务，可配合客户开展项目立项、手续办理、专家审核等工作。</div>
            </div>
          </div>

          <div class="item-tech-wrap">
            <img src="../../../assets/imgs/gykf-ic.png">
            <div class="info-wrap">
              <div class="title">工艺开发</div>
              <div class="desc">根据客户技术需求，提供针对性工艺开发，提供样品分析检测、工艺研发、小试试验及工艺包设计等服务，可与客户开展联合工艺包开发。</div>
            </div>
          </div>

          <div class="item-tech-wrap">
            <img src="../../../assets/imgs/zszz-ic.png">
            <div class="info-wrap">
              <div class="title">中试及示范装置EPC</div>
              <div class="desc">提供中试装置及示范装置的工艺开发、工艺包设计、工程建设、工程调试及验证试验等服务，并配合客户收集试验数据，为工业化放大提供支撑。</div>
            </div>
          </div>

          <div class="item-tech-wrap">
            <img src="../../../assets/imgs/ythjs-ic.png">
            <div class="info-wrap">
              <div class="title">CCUS全流程工程建设</div>
              <div class="desc">
                公司与上海寰球设计院、中煤科工设计院、中石化设计院、中国化学第十四建设公司等开展深度战略合作，致力于项目的EPC总包、EP总包、EMC等多种合作模式，并提供研发、初步设计、工程化设计、制造安装、运营一体化服务。
              </div>
            </div>
          </div>

          <div class="item-tech-wrap">
            <img src="../../../assets/imgs/jssjgz-ic.png">
            <div class="info-wrap">
              <div class="title">技术升级改造</div>
              <div class="desc">
                提供项目全生命周期技术服务，在项目建成后，根据运行效果结合科技发展前沿，及时向客户提供升级改造建议，保障客户的持续受益。
              </div>
            </div>
          </div>

          <div class="item-tech-wrap">
            <img src="../../../assets/imgs/cgtg-ic.png">
            <div class="info-wrap">
              <div class="title">成果推广</div>
              <div class="desc">
                支持联合工艺开发模式，并充分利用自身技术、平台、资金优势，对优势成果进行推广，实现发展共赢。
              </div>
            </div>
          </div>
        </template>
        <template v-else>

          <div class="hxjs-wrap">
            <img class="img" src="../../../assets/imgs/blue-top.png">

            <div class="title">{{ hexinList[currHexin].title }}</div>
            <img class="titleimg" :src="hexinList[currHexin].head_img">

          </div>
          <div style="height: 40px"></div>
        </template>
        <div id="p1" class="content-w">
        </div>
        <div style="height: 40px"></div>
      </div>
    </div>
  </div>

</template>

<script>
import $ from 'jquery'

export default {
  name: "hexinYwFragment",
  data: () => {

    return {
      currTab: 0,
      currHexin: 0,
      isOpen: false,
      menuList: [{
        text: '业务范围',
      }, {
        text: '核心技术',
      }],
    }
  },
  computed: {
    hexinList() {
      return this.$store.state.hxjs
    }
  },
  mounted() {

    if (this.$store.state.hxjs.length > 0) {
      if (this.$route.params.item) {
        this.isOpen = true
        this.currTab = 1
        this.currHexin = this.hexinList.indexOf(this.$route.params.item)

        console.log(this.currHexin)
        $("#p1").empty()
        $("#p1").append(this.hexinList[this.currHexin].detail);
      }
    }

  },
  watch: {
    currHexin(val) {

      $("#p1").empty()
      $("#p1").append(this.hexinList[val].detail);

    },
    isOpen(val) {
      if (val) {
        $("#p1").empty()
        $("#p1").append(this.hexinList[this.currHexin].detail);
      }
    }
  },
  methods: {
    goHome() {//首页
      this.$router.replace('/home')
    },
    qiehuanTab(i) {//走进探索
      $("#p1").empty()

      if (this.currTab == 1 && i == 1) {
        this.isOpen = !this.isOpen
      } else {

        if (this.currTab == 0)
          this.isOpen = true
        else
          this.isOpen = false
      }
      this.currTab = i

    },
    qiehuanHxTab(index) {//核心技术切换
      this.currHexin = index
    }

  }
}
</script>

<style lang="less" scoped>
.home-wrap {
  width: 1400px;
  min-width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  flex-direction: column;

  .top-img {
    width: 100%;
    min-width: 1400px;
  }

}
.contact-us-wrap {
  width: 100%;
  min-height: 100%;
  padding-top: 10px;
  min-width: 1400px;
  display: flex;
  background-color: white;
  justify-content: center;

  .left-wrap {
    width: 230px;
    display: flex;
    flex-direction: column;

    .head-txt {
      background-color: #063979;
      width: 100%;
      height: 60px;
      line-height: 60px;
      color: white;
      font-size: 18px;
      padding-left: 20px;
    }

    .item-txt {
      width: 100%;
      background-color: #DEDFE0;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      font-size: 16px;
      color: #666666;
      margin-top: 2px;
    }

    .item-txt-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }

    .item-txt2 {
      width: 100%;
      background-color: #DEDFE0;
      height: 50px;
      align-items: center;
      display: flex;
      padding-left: 20px;
      margin-top: 2px;

      .item2-txt {
        font-size: 16px;
        color: #666666;
        flex: 1;
      }

      img {
        margin-right: 5px;
        width: 20px;
      }
    }

    .item-txt2-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }

    .hxitem-txt {
      width: 100%;
      background-color: #F3F4F5;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      color: #666666;
      margin-top: 2px;
    }

    .hxitem-txt-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }
  }

  .right-wrap {
    display: flex;
    flex-direction: column;
    width: 970px;
    margin-left: 10px;

    .text-title {
      color: #666666;
      font-size: 16px;
      display: flex;
      height: 34px;
      align-items: center;
      position: relative;

      .c-us {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .a-a {
        margin-left: 5px;
        margin-right: 5px;
        font-size: 16px;
        color: #666666;
      }

      .a-a:hover {
        text-decoration: underline;
        color: #22B5A8;
      }

      .c-line {
        background-color: #333333;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 20px;
      }
    }

    .ywfw-top-wrap {
      background-image: linear-gradient(to right, #1362A2, #84B2EF);
      width: 100%;
      margin-top: 26px;
      display: flex;
      position: relative;
      flex-direction: column;

      img {
        position: absolute;
        top: 16px;
        left: 20px;
      }

      .text {
        color: white;
        font-size: 18px;
        margin-left: 40px;
      }
    }

    .item-tech-wrap {
      width: 100%;
      height: 100px;
      display: flex;
      margin-top: 16px;
      background-color: #F3F4F5;

      img {
        width: 100px;
        height: 100px;
      }

      .info-wrap {
        margin-left: 16px;
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;

        .title {
          color: #333333;
          font-size: 18px;
          margin-top: 14px;
        }

        .desc {
          color: #333333;
          font-size: 16px;
          margin-top: 10px;
          margin-right: 20px;
        }
      }
    }

    .hxjs-wrap {
      background-color: #F3F4F5;
      width: 100%;
      margin-top: 26px;
      display: flex;
      position: relative;
      align-items: center;
      height: 192px;
      justify-content: flex-end;

      .img {
        position: absolute;
        top: 16px;
        left: 20px;
      }

      .title {
        position: absolute;
        top: 40px;
        left: 40px;
        font-size: 18px;
      }

      .titleimg {
        width: 160px;
        height: 80px;
        border-radius: 5px;
        margin-right: 40px;
        border: white solid 3px;
      }

      .content-w {
        width: 100%;
        margin-bottom: 40px;
        padding-top: 40px;
      }
    }
  }
}
</style>
